import React from 'react';
import "./howto.css";
import howto from "../data/howto.json";
import { data } from '../data/data';
const Howto = ()=>{   
    const howtos = howto.map((key, ind)=>{
        return <div key={ind}> 
        <h2  className="howto">{key.title}</h2>
        <p  className="howto">{key.info}</p>
        </div>
    })
    return (
        <div className="how-to-container">
        <div>
            <h1 className="howtotitle"> Family Feud </h1>
        </div>
        <div>
            <h1 className="howto"> How to play</h1>
            {howtos}
        </div>
    </div>
    )
}
export default Howto;